import Swal, { SweetAlertResult } from 'sweetalert2'
import * as moment from "moment";

moment.locale("es-PE");
export function timerOut(timer: number) {
  let promise = new Promise((resolve) => {
    setTimeout(() => {
      resolve(true);
    }, timer);
  });
  return promise;
}


export function setConfigTable(scrollX2: boolean) {
  let config;
  return config = {
    scrollY: "300px",
    scrollX: scrollX2,
    paging: false,
    language: languageTable(),
    searching: false,
    order: [1, 'asc'],
    //   // pagingType: 'full_numbers',
    // //   pageLength: 5,
    // // lengthMenu : [5, 10, 25],
    processing: true,
    // responsive:true
  };
}

export function setConfigTableModalLetras() {
  let config;
  return config = {
    scrollY: "210px",
    scrollX: false,
    paging: false,
    language: languageTable(),
    searching: false,
    processing: true,
  };
}

export function setConfigTableModalBusqueda(scrollX2: boolean) {
  let config;
  return config = {
    scrollY: "300px",
    scrollX: scrollX2,
    paging: false,
    language: languageTable(),
    searching: true,

    //   // pagingType: 'full_numbers',
    // //   pageLength: 5,
    // // lengthMenu : [5, 10, 25],
    processing: true,
    // responsive:true
  };
}

export function setConfigTableModalBusqueda2(scrollX2: boolean) {
  let config;
  return config = {
    scrollY: "250px",
    scrollX: scrollX2,
    paging: false,
    language: languageTable(),
    searching: true,

    //   // pagingType: 'full_numbers',
    // //   pageLength: 5,
    // // lengthMenu : [5, 10, 25],
    processing: true,
    // responsive:true
  };
}

export function setConfigTableModalBusqueda3(scrollX2: boolean) {
  let config;
  return config = {
    scrollY: "250px",
    scrollX: scrollX2,
    paging: false,
    language: languageTable(),
    searching: false,

    //   // pagingType: 'full_numbers',
    // //   pageLength: 5,
    // // lengthMenu : [5, 10, 25],
    processing: true,
    // responsive:true
  };
}

//Metodo para tabla responsive - MENU DESPLEGABLE
export function setConfigTableBuscador(scrollX2: boolean) {
  let config;
  return config = {
    scrollY: "300px",
    scrollX: scrollX2,
    paging: false,
    language: languageTable(),
    searching: true,

    //   // pagingType: 'full_numbers',
    // //   pageLength: 5,
    // // lengthMenu : [5, 10, 25],
    processing: true,
    // responsive:true
  };
}

//Metodo para tabla responsive - MENU DESPLEGABLE
export function setConfigTableResponsive(scrollX2: boolean) {
  let config;
  return config = {
    paging: false,
    language: languageTable(),
    searching: false,
    processing: true,
  };
}

export function languageTable(): any {
  let spanish_datatables
  return spanish_datatables = {
    processing: "Procesando...",
    search: "Buscar:",
    lengthMenu: "Mostrar _MENU_ elementos",
    info: "Mostrando desde _START_ al _END_ de _TOTAL_ elementos",
    infoEmpty: "Mostrando ningún elemento.",
    infoFiltered: "(filtrado _MAX_ elementos total)",
    infoPostFix: "",
    loadingRecords: "Cargando registros...",
    zeroRecords: "No se encontraron registros",
    emptyTable: "No hay datos disponibles en la tabla",
    paginate: {
      first: "Primero",
      previous: "Anterior",
      next: "Siguiente",
      last: "Último"
    },
    aria: {
      sortAscending: ": Activar para ordenar la tabla en orden ascendente",
      sortDescending: ": Activar para ordenar la tabla en orden descendente"
    }
  }

}

export function basicAlert(texto: string, icono: any, confirmButtonText: string, showCancelButton?: boolean, cancelButtonText?: string, input?: any) {
  let focus: boolean = false;
  Swal.fire({
    // title: titulo,
    allowOutsideClick: false,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    text: texto,
    icon: icono,
    confirmButtonText: confirmButtonText,
    showCancelButton: showCancelButton,
    cancelButtonText: cancelButtonText,
    preConfirm: () => {
      setTimeout(() => {
        if (input) {
          input.nativeElement.focus();
        }
      }, 300);
    }
  })

    ;
}

export function basicAlert_Html(texto: string, icono: any, confirmButtonText: string, showCancelButton?: boolean, cancelButtonText?: string, input?: any) {
  Swal.fire({
    allowOutsideClick: false,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    html: texto,
    width: '600px',
    icon: icono,
    confirmButtonText: confirmButtonText,
    showCancelButton: showCancelButton,
    cancelButtonText: cancelButtonText,
    preConfirm: () => {
      setTimeout(() => {
        if (input) {
          input.nativeElement.focus();
        }
      }, 300);
    }
  });
}



export function alertaConfirmacion(mensaje: string, tipoAlerta: any, focusCancelar: boolean = false, focusConfirmar: boolean = true,) {
  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      text: mensaje,
      icon: tipoAlerta,
      focusCancel: focusCancelar,
      focusConfirm: focusConfirmar,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    }).then((result) => {
      return resolve(result.value);
    });
  })

  return ejecutarAlerta;
}

export function alertaConfirmacion2(mensaje: string, tipoAlerta: any, focusCancelar: boolean = false, focusConfirmar: boolean = true,) {
  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      html: mensaje,
      icon: tipoAlerta,
      focusCancel: focusCancelar,
      focusConfirm: focusConfirmar,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    }).then((result) => {
      return resolve(result.value);
    });
  })

  return ejecutarAlerta;
}

export function alertaConfirmacion3(mensaje: string, tipoAlerta: any, focusCancelar: boolean = true, focusConfirmar: boolean = false,) {
  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      html: mensaje,
      icon: tipoAlerta,
      focusCancel: focusCancelar,
      focusConfirm: focusConfirmar,
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Si',
      cancelButtonText: 'No'
    }).then((result) => {
      return resolve(result.value);
    });
  })

  return ejecutarAlerta;
}
//YYYY-MM-DD
export function obtenerFechaActual(formato: string) {
  return moment(new Date()).format(formato);
}

export function obtenerFechaSeleccionada(fecha: string, formato: any) {
  try {
  console.log("guardando fecha correcta")
  console.log(moment(fecha).format(formato))
  let fechamoment =  moment(fecha).format(formato);
  if(fechamoment == 'Fecha inválida')
  fechamoment = ''
  
  return fechamoment;
  
  } catch (e) { 
    console.log("fecha incorrecta")
    return null;
  }

}

export function obtenerHora(formato: string) {
  return moment().format(formato);
}

export function obtenerDias(dias: number) {
  return moment().add(dias, 'd');
}

export function agregarDias(fecha: string,dias: number) {
  return moment(fecha).add(dias, 'd');
}

export function calcular_precio_total(documentoDet: any) {
  let total: number = 0.0;
  total = documentoDet.preuni * documentoDet.cantid;
  return this.calculaDescuentos(total, documentoDet.pordes1, documentoDet.pordes2, documentoDet.pordes3, documentoDet.pordes4);
}

export function calculaDescuentos(importe: number, des1: number, des2: number, des3: number, des4: number) {
  let result: number;
  result = importe;
  result *= ((100 - des1) / 100);
  result *= ((100 - des2) / 100);
  result *= ((100 - des3) / 100);
  result *= ((100 - des4) / 100);
  return result;
}

export function openObservacion(observacion: string) {
  Swal.fire({
    html: `<div>
              <textarea class="small" style="width: 100%;" rows="6" disabled>${observacion}</textarea>
            <div> `,
    showCloseButton: false,
    showCancelButton: false,
    focusConfirm: true,
    confirmButtonText: "Aceptar"
  });
}

export function openDescripcion(descripcion: string) {
  Swal.fire({
    html: `<div>
    <label class="small">${descripcion}</label>
  <div> `,
    showCloseButton: false,
    showCancelButton: false,
    focusConfirm: true,
    confirmButtonText: "Aceptar"
  });
}

export function validarCodigoExistentesComercial(tipoInput: string, codigoInputado: number, array: any[]): boolean {
  return !!JSON.stringify(array.find(codigo => (tipoInput === 'motivo' ? codigo.codmot : tipoInput === 'almacen' ? codigo.codalm : tipoInput === 'vehículo' ? codigo.codveh : tipoInput === 'condicionPago' ? codigo.codpag : tipoInput === 'documento' ? codigo.tipdoc : tipoInput === 'serie' ? codigo.series : tipoInput === "moneda" ? codigo.codmon : tipoInput === "vendedor" ? codigo.codven : '') == codigoInputado));
}

export function validarCodigoExistentesArticulo(tipoInput: string, codigoInputado: number, array: any[]): boolean {
  return !!JSON.stringify(array.find(codigo => (tipoInput === 'almacen' ? codigo.codalm : '') == codigoInputado));
}

export function validarCodigoExistentesDocumentoGenerico(tipoInput: string, codigoInputado: number, array: any[]): boolean {
  return !!JSON.stringify(array.find(codigo => (tipoInput === 'sucursal' ? codigo.codsuc : tipoInput === "moneda" ? codigo.codmon : '') == codigoInputado));
}

export function validarCodigoExistentesImportarListaPrecio(tipoInput: string, codigoInputado: number, array: any[]): boolean {
  return !!JSON.stringify(array.find(codigo => (tipoInput === 'clase' ? codigo.clase : tipoInput === "moneda" ? codigo.codmon : tipoInput === "codigo" ? codigo.codven : '') == codigoInputado));
}

export function validarCodigoExistentesRC(tipoInput: string, codigoInputado: number, array: any[]): boolean {
  return !!JSON.stringify(array.find(x => (tipoInput === 'comprobante' ? x.codigo : tipoInput === 'moneda' ? x.codmon : tipoInput === "igv_retencion" ? x.codfac : tipoInput === "bien_servicio" ? x.codfac : tipoInput === "debe_haber" ? x.codigo : tipoInput === "motivo" ? x.codigo : tipoInput === "cuenta_gasto" ? x.cuenta : tipoInput === "centro_costo" ? x.codigo : tipoInput === "cuenta_alternativa" ? x.cuenta : '') == codigoInputado));
}

export function basicAlertHTML(texto: string, icono: any, confirmButtonText: string, showCancelButton?: boolean, cancelButtonText?: string, input?: any) {
  Swal.fire({
    // title: titulo,
    allowOutsideClick: false,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    html: texto,
    icon: icono,
    confirmButtonText: confirmButtonText,
    showCancelButton: showCancelButton,
    cancelButtonText: cancelButtonText,
    preConfirm: () => {
      setTimeout(() => {
        if (input) {
          input.nativeElement.focus();
        }
      }, 300);
    }
  });
}

export function alertaConfirmacionHTML(mensaje: string, tipoAlerta: any) {
  let focus: boolean = false;
  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      html: mensaje,
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      icon: tipoAlerta,
      confirmButtonText: 'Aceptar',

      // showCancelButton: showCancelButton,
    }).then((result) => {
      return resolve(result.value);
    });
  })

  return ejecutarAlerta;
}

export function alertaConfirmacionHTML3(mensaje: string, tipoAlerta: any) {
  let focus: boolean = false;
  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      html: mensaje,
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      icon: tipoAlerta,
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',

      focusCancel: false,
      focusConfirm: true,
      showCancelButton: true,
      // showCancelButton: showCancelButton,
    }).then((result) => {
      return resolve(result.value);
    });
  })

  return ejecutarAlerta;
}

export function alertaConfirmacionHTML2(mensaje: string, tipoAlerta: any, input?: any) {
  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      html: mensaje,
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      icon: tipoAlerta,
      confirmButtonText: 'Aceptar',
      preConfirm: () => {
        setTimeout(() => {
          if (input) {
            input.nativeElement.focus();
          }
        }, 300);
      }
      // showCancelButton: showCancelButton,
    }).then((result) => {
      return resolve(result.value);
    });
  })

  return ejecutarAlerta;
}


export function openReutilizar(documento: string) {
  const inputCSS = `
  <style>
  .style-number-input {
    margin-top: 20px;  
    margin-bottom: 20px;  
    width: 65%; 
    padding: 12px;
    border: 1px solid #d9d9d9 !important; 
    border-radius: 4px; 
    font-size:  1.2rem; 
    color: #585858 !important; 
    transition: border 0.1s ease;
  } 
  .style-number-input:focus {
   border-color: #aed1ee !important;
    box-shadow: 0 0 5px rgba(102, 175, 233, .5), 0 0 0 3px rgba(174, 209, 238, 0.5);
    outline: none; 
    color: #585858; 
  }
  .style-number-input::-webkit-inner-spin-button,
  .style-number-input::-webkit-outer-spin-button {
    -webkit-appearance: none; 
    margin: 0; 
  }
</style>`
;
  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      html: inputCSS +
        '<label> Serie </label> <br>' +
        '<input id="serieIn" class="swal2-input" style="text-transform: uppercase;"> <br>' +
        '<label> Número </label> <br>' +
        '<input id="numeroIn" type="number" class="style-number-input" min="0" step="1">',
      allowOutsideClick: false,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-search"></i> Buscar ' + documento,
      confirmButtonColor: '#3085d6',
      showCancelButton: true,
      cancelButtonColor: '#FFB22B',
      cancelButtonText: '<i class="fa fa-times-circle"></i> Cancelar',
      preConfirm: () => {
        return [
          (<HTMLInputElement>document.getElementById('serieIn')).value,
          (<HTMLInputElement>document.getElementById('numeroIn')).value,
        ];
      },
      didOpen: () => {
        const numeroInput = document.getElementById('numeroIn') as HTMLInputElement;
        numeroInput.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            Swal.clickConfirm();
          }
        });
      }
    }).then(result => {
      if (result.isConfirmed) {
        resolve(result.value);
      }
    });
  });
  return ejecutarAlerta;
}

export function filtrarCoincidenciaArrayTransportista(array: any, query: string) {
  return array.filter(function (el) {
    return el.descri.toLowerCase().indexOf(query.toLowerCase()) > -1;
  })
}

export function filtrarCoincidenciaArrayCuenta(array: any, query: string) {
  return array.filter(function (el) {
    return el.nombre.toLowerCase().indexOf(query.toLowerCase()) > -1;
  })
}
export function filtrarCoincidenciaArrayDocume(array: any, query: string) {
  return array.filter(function (el) {
    return el.descri.toLowerCase().indexOf(query.toLowerCase()) > -1;
  })
}

export function filtrarCoincidenciaArrayCuentaCostos(array: any, query: string) {
  const resultPosts = [];

  for (const post of array) {
    if (post.nombre.toLowerCase().indexOf(query.toLowerCase()) > -1) {
      resultPosts.push(post);
    };
  };

  return resultPosts;
}

export function filtrarCoincidenciaArrayCentroCostos(array: any, query: string) {
  const resultPosts = [];

  for (const post of array) {
    if (post.descri.toLowerCase().indexOf(query.toLowerCase()) > -1) {
      resultPosts.push(post);
    };
  };

  return resultPosts;
}

export function filtrarCoincidenciaArrayCuentaCostosCod(array: any, query: string) {
  const resultPosts = [];

  for (const post of array) {
    if (post.cuenta.toLowerCase().indexOf(query.toLowerCase()) > -1) {
      resultPosts.push(post);
    };
  };

  return resultPosts;
}

export function filtrarCoincidenciaArrayCentroCostoCod(array: any, query: any) {
  const resultPosts = [];

  for (const post of array) {
    if (post.codigo.toLowerCase().indexOf(query.toLowerCase()) > -1) {
      resultPosts.push(post);
    };
  };

  return resultPosts;
}

export function filtrarCoincidenciaArraySubCentroCostoCod(array: any, query: any) {
  const resultPosts = [];

  for (const post of array) {
    if (post.codcli.indexOf(query) > -1) {
      resultPosts.push(post);
    };
  };

  return resultPosts;
}

export function filtrarCoincidenciaArrayProyectoCod(array: any, query: any) {
  const resultPosts = [];

  for (const post of array) {
    if (post.codigo.indexOf(query) > -1) {
      resultPosts.push(post);
    };
  };

  return resultPosts;
}

export function validarInputVacio(value: any): string {
  if (value != null) {
    return value.toString();
  }
  else {
    return ''
  }

}

export function setConfigTableDropDownd() {
  let config;
  return config = {
    scrollY: "200px",
    scrollX: false,
    paging: false,
    language: languageTable(),
    searching: false,
    processing: true,
  };
}

export function setConfigTableDropDown(codigo: string, descri: string) {
  let config;
  return config = {
    singleSelection: false,
    idField: codigo,
    textField: descri,
    placeholder: 'Seleccionar uno o varios',
    selectAllText: 'Seleccionar todas las cuentas',
    unSelectAllText: 'Deseleccionar todos',
    searchPlaceholderText: 'Escriba un nombre o número de cuenta para Buscar',
    itemsShowLimit: 3,
    enableCheckAll: false,
    allowSearchFilter: true,
    clearSearchFilter: true,
    closeDropDownOnSelection: true
  };
}

export function setConfigTableDConsultas() {
  let config;
  return config = {
    scrollY: "300px",
    scrollX: true,
    paging: false,
    language: languageTable(),
    searching: false,
    processing: true,
    // select: true
  };
}

export function setConfigTableDropDownSingle(codigo: string, descri: string, searchtext: string) {
  let config;
  return config = {
    singleSelection: true,
    defaultOpen: false,
    idField: codigo,
    textField: descri,
    // selectAllText: "Seleccionar centro de costo",
    searchPlaceholderText: searchtext,
    // unSelectAllText: "UnSelect All",
    enableCheckAll: true,
    // itemsShowLimit: 3,
    allowSearchFilter: true
  };
}

export function openObservacionEdit(observ: string) {
  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      html: ` <div>
              <textarea id="observIn" class="large" style="width: 100%;  height: 100%;"  rows="6">${observ}</textarea>
              <div> `,
      allowOutsideClick: false,
      focusConfirm: false,
      confirmButtonText: '<i class="far fa-save"></i> Guardar',
      confirmButtonColor: '#3085d6',
      showCancelButton: true,
      cancelButtonColor: '#FFB22B',
      cancelButtonText: '<i class="fa fa-times-circle"></i> Cancelar',
      preConfirm: () => {
        return resolve([
          (<HTMLInputElement>document.getElementById('observIn')).value
        ])
      }
    })
  })
  return ejecutarAlerta;
}

export const LANGUAGE = {
  sProcessing: "Procesando...",
  sLengthMenu: "Mostrar _MENU_ registros",
  sZeroRecords: "No se encontraron resultados",
  sEmptyTable: "Ningún dato disponible en esta tabla",
  // "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
  sInfo: "Mostrando un total de _TOTAL_ registros",
  sInfoEmpty: "Mostrando registros del 0 al 0 de un total de 0 registros",
  sInfoFiltered: "(filtrado de un total de _MAX_ registros)",
  sInfoPostFix: "",
  sSearch: "Buscar:",
  sUrl: "",
  sInfoThousands: ",",
  sLoadingRecords: "Cargando...",
  oPaginate: {
    sFirst: "Primero",
    sLast: "Último",
    sNext: "Siguiente",
    sPrevious: "Anterior"
  }
};

export function alertaRouter(texto: string, icono: any, confirmButtonText: string, showCancelButton?: boolean, cancelButtonText?: string, input?: any) {
  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      allowOutsideClick: false,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      text: texto,
      icon: icono,
      confirmButtonText: confirmButtonText,
      showCancelButton: showCancelButton,
      cancelButtonText: cancelButtonText,
    }).then((result) => {
      return resolve(result.value);
    });
  })

  return ejecutarAlerta;
}

export function openInsertarNumint(documento: string) {
  const inputCSS = `
  <style>
  .style-number-input {
    margin-top: 20px;  
    margin-bottom: 20px;  
    width: 65%; 
    padding: 12px;
    border: 1px solid #d9d9d9 !important; 
    border-radius: 4px; 
    font-size:  1.2rem; 
    color: #585858 !important; 
    transition: border 0.1s ease;
  } 
  .style-number-input:focus {
    border-color: #aed1ee !important;
    box-shadow: 0 0 5px rgba(102, 175, 233, .5), 0 0 0 3px rgba(174, 209, 238, 0.5);
    outline: none; 
    color: #585858; 
  }
  .style-number-input::-webkit-inner-spin-button,
  .style-number-input::-webkit-outer-spin-button {
    -webkit-appearance: none; 
    margin: 0; 
  }
</style>`;


  var ejecutarAlerta = new Promise(function (resolve) {
    Swal.fire({
      html: inputCSS + '<div class="leftD">Num. Int</div>' +
      '<input id="numint" type="number" class="style-number-input" min="0" step="1" >',
      allowOutsideClick: false,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-search"></i> Buscar ' + documento,
      confirmButtonColor: '#3085d6',
      showCancelButton: true,
      cancelButtonColor: '#FFB22B',
      cancelButtonText: '<i class="fa fa-times-circle"></i> Cancelar',
      preConfirm: () => {
        return [
          (<HTMLInputElement>document.getElementById('numint')).value,
        ]
      },
      didOpen: () => {
        const numint = document.getElementById('numint') as HTMLInputElement;
        numint.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            Swal.clickConfirm();
          }
        });
      }
    }).then(result => {
      if (result.isConfirmed) {
        resolve(result.value);
      }
    });
  });
  return ejecutarAlerta;
}